/* eslint-disable @typescript-eslint/no-explicit-any */
import L from 'lodash'

import { getCookie, setCookie } from '@straal/core/utils/cookieHelpers'

type TPromiseResolver = (value?: unknown) => any
type TPromiseRejecter = (value?: unknown) => any

type TAjaxCallback = (
  xhr: XMLHttpRequest,
  resolve: TPromiseResolver,
  reject: TPromiseRejecter,
  data: any,
) => void

type TLoginData = {
  email: string
}

const HTTP_STATUS_OK = 200
const HTTP_STATUS_FORBIDDEN = 403

export const ajax = function(
  method = 'GET',
  url: string,
  callback: TAjaxCallback,
  data: any = '',
): Promise<any> {
  return new Promise(function(resolve, reject): void {
    const token = getCookie('csrf_token')
    const xhr = new XMLHttpRequest()
    xhr.open(method, url, true)
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    if (L.isString(token)) xhr.setRequestHeader('X-CSRF-Token', token)
    // eslint-disable-next-line fp/no-mutation
    xhr.onreadystatechange = function(): void {
      callback(xhr, resolve, reject, data)
    }
    xhr.send(JSON.stringify(data))
  })
}

export const redirectToLogin = function(): void {
  // eslint-disable-next-line lodash/prefer-lodash-method
  window.location.replace('/login')
}
export const redirectToPasswordExpired = function(email: string): void {
  // eslint-disable-next-line lodash/prefer-lodash-method
  window.location.replace(`/expired?email=${email}`)
}
export const redirectToPanel = function(): void {
  // eslint-disable-next-line fp/no-mutation
  window.location.pathname = '/'
}

const onLoginPromise = function(
  xhr: XMLHttpRequest,
  resolve: TPromiseResolver,
  reject: TPromiseRejecter,
  data: TLoginData,
): void {
  if (L.isEqual(xhr.readyState, XMLHttpRequest.DONE)) {
    const successCallback = (): void => {
      // Set cookie for kompas to send LOGIN event to Grafana
      setCookie('login', 'true')
      redirectToPanel()
    }
    const forbiddenCallback = (): void => {
      redirectToPasswordExpired(data.email)
    }
    const rejectCallback = (): void => reject(xhr)
    const matchEqual = L.curry(L.isEqual)

    const statusCond = L.cond<number, void>([
      [matchEqual(HTTP_STATUS_OK), successCallback],
      [matchEqual(HTTP_STATUS_FORBIDDEN), forbiddenCallback],
      [L.stubTrue, rejectCallback],
    ])
    statusCond(xhr.status)
  }
}

const onLogout = function(xhr: XMLHttpRequest): void {
  const isRequestDone = L.isEqual(xhr.readyState, XMLHttpRequest.DONE)
  const hasStatus = xhr.status !== 0
  const shouldRedirect = isRequestDone && hasStatus

  return shouldRedirect ? redirectToLogin() : L.noop()
}

export const closeSession = L.partial(ajax, 'POST', '/logout', onLogout)
export const createSession = L.partial(ajax, 'POST', '/login', onLoginPromise)
